module.exports = __webpack_public_path__ + "img/logo_T-white.4e3556c9.svg";